export const environment = {
  production: false,
  debugMode: false,
  appVersion: '1.5.6-6229be6-20261013193237',
  /**
   * Login y API REST (HTTPS en 443 → app :8002). Variantes HTTP :8002 / localhost solo para ng serve local.
   */
  apiUrl: 'https://apip-sat.tideapps.com/api/v1', // 'http://apip-sat.tideapps.com:8002/api/v1', // 'http://localhost:8008/api/v1',
  /**
   * Misma base HTTPS que apiUrl en satapp. Con ng serve en http://localhost puede usarse el override :8002.
   * En HTTPS el cliente ignora archivosApiUrl si es http: y usa apiUrl (evita mixed content).
   */
  archivosApiUrl: 'https://apip-sat.tideapps.com/api/v1', // 'http://apip-sat.tideapps.com:8002/api/v1', // 'http://localhost:8002/api/v1',
  uploadsUrl: 'https://apip-sat.tideapps.com/uploads', // 'http://apip-sat.tideapps.com:8002/uploads', // 'http://localhost:8002/uploads',
  claveUnica: {
    baseUrl: 'https://sistemas.indap.cl/claveunica.php',
    clientId: 'app_tide',
    /** Clave Única no funciona bien en localhost; usar returnUrl de satapp o callback local según entorno. */
    returnUrl: 'https://satapp.tideapps.com/callback', // 'http://localhost:4200/callback',
    logoutBaseUrl: 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout',
  },
  googleAnalytics: {
    enabled: false,
    measurementId: 'G-MYKKZNQB7X',
  },
  /** Flag de build; el override en runtime se gestiona con DebugModeService (7 toques en avatar del menú). */
  DEBUG_MODE: false,
  /** Aviso en login: URL QA dejará de estar disponible tras migración a producción. */
  mostrarAvisoMigracionQa: true,
  /**
   * Widget empotrable ia-demo (embed.js).
   * Activar/desactivar: `enabled: true` monta el widget (sesión autenticada + online);
   * `enabled: false` lo deja apagado en este entorno. No depende de DebugModeService.
   * Local Docker: widget :8081, API :8004.
   * Remoto (VPS): widget.asistenteia.tideapps.com / api.asistenteia.tideapps.com
   */
  asistenteIaEmbed: {
    enabled: false,
    /** asistente-ia-widget — host :8081 */
    embedScriptUrl: 'https://widget.asistenteia.tideapps.com/embed.js', // 'http://localhost:8081/embed.js', // 'http://54.174.39.130:8081/embed.js'
    /** asistente-ia-api — host :8004 */
    apiBase: 'https://api.asistenteia.tideapps.com', // 'https://api.asistenteia.tideapps.com', // 'http://localhost:8004', // 'http://54.174.39.130:8004'
    apiKey: 'demo-tenant-key',
    tenant: 'indap-sat',
    title: 'Asistente IA',
    primaryColor: "#005CAA",
    headerColor: "#0f172a",
    userBubbleColor: "#334155",
    launcherIcon: "chat",
  },
};
